import { CssBaseline, ThemeProvider } from '@mui/material';
import { Main } from 'components';
import { AnalyticsProvider } from 'contexts/Analytics/Analytics';
import { initSentry } from 'setup/sentry';

initSentry();
import { ApiProvider } from 'contexts/Api/Api';
import { ContentProvider } from 'contexts/Content/Content';
import { PopupsProvider } from 'contexts/Popups/Popups';
import { SettingsProvider } from 'contexts/Settings/Settings';
import { SoundsProvider } from 'contexts/Sounds/Sounds';
import { StagingProvider } from 'contexts/Staging/Staging';
import gsap from 'gsap';
import MotionPathPlugin from 'gsap/MotionPathPlugin';
import type { AppProps } from 'next/app';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { theme } from 'setup';

gsap.registerPlugin(MotionPathPlugin);

export default function App({ Component, pageProps }: AppProps) {
    const fullScreenHandle = useFullScreenHandle();
    const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging';

    return (
        <StagingProvider isStaging={isStaging}>
            <FullScreen handle={fullScreenHandle}>
                <AnalyticsProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <ApiProvider>
                            <ContentProvider>
                                <SettingsProvider>
                                    <SoundsProvider>
                                        <PopupsProvider>
                                            <Main fullScreenHandle={fullScreenHandle}>
                                                <Component {...pageProps} />
                                            </Main>
                                        </PopupsProvider>
                                    </SoundsProvider>
                                </SettingsProvider>
                            </ContentProvider>
                        </ApiProvider>
                    </ThemeProvider>
                </AnalyticsProvider>
            </FullScreen>
        </StagingProvider>
    );
}
